/* eslint-disable flowtype/no-types-missing-file-annotation */
import {connect} from 'react-redux';
import React from 'react';
import {
    TripBoardButton,
    TripBoardsApolloProvider
} from '@homeaway/react-trip-board-button';

import {State as ReduxState} from '../../reducers';
import {State as AbacusState} from '../../reducers/abacus';

import {ListingShape as HitListingShape} from '../Hit/Hit';

type StateProps = {
    abacus: AbacusState;
    adultsCount?: number;
    childrenCount?: number;
    isMobile?: boolean;
    endDate?: string;
    petIncluded?: boolean;
    siteName: string;
    startDate?: string;
    q?: string;
};

export type Props = {
    listing: HitListingShape;
    isMapHit?: boolean;
} & StateProps;

const TripBoardComponent = ({
    abacus,
    adultsCount,
    childrenCount,
    endDate,
    listing: {
        propertyMetadata: {headline},
        images,
        listingId,
        averageRating,
        reviewCount
    },
    isMapHit = false,
    isMobile,
    petIncluded,
    q: searchTerm,
    siteName,
    startDate
}: Props) => (
    <TripBoardsApolloProvider listingId={listingId}>
        {(tripBoardsApolloProvider) => (
            <TripBoardButton
                {...tripBoardsApolloProvider}
                abacus={abacus}
                adultsCount={adultsCount}
                childrenCount={childrenCount}
                endDate={endDate}
                expandedButton={!isMobile}
                headline={headline}
                listingId={listingId}
                petIncluded={petIncluded}
                rating={averageRating}
                reviewCount={reviewCount}
                searchTerm={searchTerm}
                siteName={siteName}
                startDate={startDate}
                tabIndex={-1}
                thumbnailUrl={images && images[0] && images[0].c9_uri}
                useNativeEventListener={isMapHit}
                redOnHover
            />
        )}
    </TripBoardsApolloProvider>
);

const mapStateToProps = (state: ReduxState): StateProps => {
    const {abacus, searchParams, system} = state;
    const {siteName, isMobile, isTablet} = system;
    const {
        arrival: startDate,
        departure: endDate,
        adultsCount,
        childrenCount,
        petIncluded,
        q
    } = searchParams.params;

    return {
        abacus,
        adultsCount,
        childrenCount,
        endDate,
        isMobile: isMobile && !isTablet,
        petIncluded,
        siteName,
        startDate,
        q
    };
};

export default connect(mapStateToProps)(TripBoardComponent);
